import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';
import { repositories, } from 'api';
import { BasicApiException, } from 'common/types';

export const fetchProducts = createAsyncAction(
    types.FETCH_PRODUCTS_REQUEST,
    types.FETCH_PRODUCTS_SUCCEEDED,
    types.FETCH_PRODUCTS_FAILED,
)<types.ProductsFilters | never | any, repositories.products.CollectionTypes.ProductsType, BasicApiException<types.ProductsErrorType>>();
